const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const generateAiTemplate = async ({ prompt, token }) => {
  const response = await fetch(`${API_BASE_URL}/ai/generate-template`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ prompt })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'AI template request failed.');
  }

  return data.template;
};
